import { Relevance } from '../../modules/topic-tag-scoring/models/topic-tag-scoring';
import { MarketingPlatform } from './contentMarketing.interface';
import { TagType } from './tags.interface';

export interface ContentType {
  id: number;
  videoUrl: string;
  name: string;
}

export interface SubCategoryType {
  id: number;
  name: string;
  themeId: number;
}

export interface ContentRequestParams {
  filename?: string;
  title?: string;
  folder?: string;
  topics?: TagType[];
  subTopics?: TagType[];
  themes?: TagType[];
  brands?: TagType[];
  persons?: TagType[];
  identities?: TagType[];
  locations?: TagType[];
  events?: TagType[];
  authors?: TagType[];
  assetType?: string;
  videoType?: string;
  startTime?: string;
  endTime?: string;
  subTitle?: string;
  text?: string;
  rawAsset?: string;
  productionFile?: string;
  productionLink?: string;
  parentProdFile?: string;
  parentProdFileLink?: string;
  preFinalFileId?: number;
  curatedInclusion?: Relevance | null;
  relevance?: Relevance | null;
  isRemoved?: boolean;
  usedOrUnused?: string;
  pathLink?: string;
}

export interface ContentQueryParams {
  perPage: number;
  page: number;
  sort?: string;
  direction?: 'asc' | 'desc';
  q?: string;
  folder?: Folder[];
  usedOrUnused?: string;
  type?: string;
  startDate?: Date | null;
  endDate?: Date | null;
  themes?: TagType[];
  topics?: TagType[];
  subTopics?: TagType[];
  videoType?: string;
  tags?: TagType[];
  brands?: TagType[];
  persons?: TagType[];
  identities?: TagType[];
  locations?: TagType[];
  events?: TagType[];
  authors?: TagType[];
  tagName?: string;
  isRemoved?: boolean;
  assetType?: TagType[];
  platform?: TagType[];
  publishStatus?: string;
  contentType?: string;
  contentByType?: string;
  category?: SubCategoryType[];
  subCategory?: SubCategoryType[];
  scheduledPost?: boolean;
}

export interface ContentResponse {
  theme: string;
  pathLink: string;
  filename: string;
  title: string;
  createdAt?: string;
  edited: string;
  videoUrl: string;
  updatedAt: string;
  lastUpdatedAt: string;
  description?: string;
  id: number;
  duration?: string;
  startTime?: string;
  endTime?: string;
  folder?: string;
  brands?: TagType[];
  personalities?: TagType[];
  themes?: TagType[];
  identity_tags?: TagType[];
  location_tags?: TagType[];
  authors?: TagType[];
  event_tags?: TagType[];
  rawAsset: string;
  productionFile: string;
  productionLink: string;
  parentProdFile: string;
  parentProdFileLink: string;
  preFinalFileId: number;
  preFinalFile?: string;
  finalFileId: number;
  subTitleFile: string;
  voiceOverFile: string;
  scriptFile: string;
  cCFile: string;
  text: string;
  videoType: string;
  type: string;
  fileType: string;
  curatedInclusionTypeId: number;
  curatedInclusionType: Relevance;
  relevanceTypeId: number;
  relevanceType: Relevance;
  assetContentType: TagType;
  assetContentTypeId: number;
  marketingPlatformDetails: MarketingPlatform[];
  published: boolean;
  mainFolder: string;
  subFolder: string;
  category: string;
  subCategory: string;
  postDescription: string;
  thumbnail: string;
  musicFileLicense?: string;
}

export interface AddVideoProps {
  video?: File;
  videos?: File[];
  type: string;
  isRemoved: boolean;
  subTitleFile: File;
  voiceOverFile: File;
  scriptFile: File;
  cCFile: File;
  brands: TagType[];
  themes: TagType[];
  topics: TagType[];
  subTopics: TagType[];
  persons: TagType[];
  identities: TagType[];
  locations: TagType[];
  events: TagType[];
  authors: TagType[];
  text: string;
  assetType: string;
  path: string;
  usedOrUnused?: string;
  selectedSubCategory?: string;
}

export type FormFields = {
  video?: File;
  videos?: File[];
  assetType: string;
  path: string;
  selectedSubCategory?: string;
};

export type PreFinalFormFields = {
  title: string;
  assetType: TagType[];
  fileName: string;
  theme: TagType[];
  topic: TagType[];
  subTopic: TagType[];
  productionFile: string;
  productionLink: string;
  rawAsset: string;
};

export type FinalFileFormFields = {
  title: string;
  fileName: string;
  startTime: string;
  endTime: string;
  text: string;
  folder: string;
  productionFile: string;
  productionLink: string;
  parentProdFile: string;
  parentProdFileLink: string;
  rawAsset: string;
  preFinalFile: string;
  preFinalFileLink: string;
  theme: TagType[];
  topic: TagType[];
  subTopic: TagType[];
  subTitleFile: File;
  voiceOverFile: File;
  scriptFile: File;
  cCFile: File;
  file: File;
  mfFile?: File;
};

export interface Folder {
  id: number;
  name: string;
  path?: string;
  path_lower?: string;
  path_display: string;
  parent_shared_folder_id?: number;
}

export interface Response {
  count: number;
  rows: ContentResponse[];
}

export const PreFinalFileDefaultValue = {
  title: '',
  assetType: [],
  fileName: '',
  theme: [],
  topic: [],
  subTopic: [],
  productionFile: '',
  productionLink: '',
  rawAsset: '',
};

export const FinalFileDefaultValue = {
  title: '',
  fileName: '',
  startTime: '',
  endTime: '',
  text: '',
  folder: '',
  productionFile: '',
  productionLink: '',
  parentProdFile: '',
  parentProdFileLink: '',
  rawAsset: '',
  preFinalFile: '',
  preFinalFileLink: '',
  theme: [],
  topic: [],
  subTopic: [],
};
